<template>
  <v-container id="partners-table" fluid>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="partners.data"
        :options.sync="options"
        :server-items-length="partners.total"
        :loading="partners.loading"
        :loading-text="$t('partners.table.loadingText')"
        :no-data-text="$t('partners.table.noData')"
        :mobile-breakpoint="mobileBreakpoint"
        :header-props="headerProps"
        :footer-props="footerProps"
        item-key="id"
        dense
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-badge :content="activeFilters.length" :value="activeFilters.length" overlap>
              <v-btn color="primary" outlined @click="filters.display = !filters.display">
                <v-icon>mdi-filter-plus-outline</v-icon>
              </v-btn>
            </v-badge>
            <v-spacer></v-spacer>
            <v-btn class="mb-2" color="primary" outlined @click="list()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            :class="[$vuetify.breakpoint.width >= mobileBreakpoint ? '' : 'pr-0']"
            text
            color="primary"
            @click="goToAction(item._id)"
          >
            <v-icon v-if="$vuetify.breakpoint.width > 767 && $vuetify.breakpoint.width < 1264" color="primary">
              mdi-magnify
            </v-icon>
            <span v-else>{{ $t('partners.table.detail') }}</span>
          </v-btn>
        </template>
      </v-data-table>

      <filter-dialog
        :key="filters.resetKey"
        v-model="filters.display"
        :fields="formFilter"
        :loadingData="partners.loading"
        :title="$t('partners.table.filters.title')"
        @confirm="filter"
      />
    </v-card>
  </v-container>
</template>

<script>
  import { EventBus } from '../../event-bus'
  import { PartnerService } from '../../services/partnerService'

  export default {
    name: 'partnersTable',
    data() {
      return {
        partners: {
          data: [],
          total: 0,
          loading: false,
        },
        options: {
          itemsPerPage: 15,
          sortDesc: [], // fix the default value change in new vuetify version
        },
        mobileBreakpoint: 768,
        partnersService: null,
        footerProps: {
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': this.$t('partners.table.perPage'),
        },
        filters: {
          resetKey: Date.now(),
          display: false,
          data: [],
        },
      }
    },
    watch: {
      options: {
        handler() {
          this.list()
        },
      },
    },
    activated() {
      if (this.$store.state.previousPath.split('/')[1] === 'partners') {
        this.reloadList()
      } else {
        this.options.itemsPerPage = 15
        this.options.page = 1
        this.options.sortBy = []
        this.options.sortDesc = []
      }
    },
    mounted() {
      this.partnersService = new PartnerService(this.$auth)
    },
    methods: {
      async list() {
        this.$set(this.partners, 'loading', true)
        EventBus.$emit('displayGlobalOverlay', { display: true, message: this.$t('partners.table.loadingText') })
        try {
          const options = structuredClone(this.options)
          for (const filter of this.activeFilters) {
            options[filter.name] = filter.value
          }
          const { data, total } = await this.partnersService.getAllPartners(options)
          this.$set(this.partners, 'data', data)
          this.$set(this.partners, 'total', total)
        } catch (e) {
          console.log(e)
        } finally {
          this.$set(this.partners, 'loading', false)
          EventBus.$emit('displayGlobalOverlay', { display: false })
        }
      },
      filter(filters) {
        this.$set(this.filters, 'data', filters)
        this.list()
      },
      goToAction(id) {
        return this.$router.push({
          name: 'partnerDetails',
          params: {
            id,
          },
        })
      },
    },
    computed: {
      formFilter() {
        return [
          {
            text: this.$t('partners.partner_id'),
            value: 'partner_id',
            filterType: 'text',
          },
          {
            text: this.$t('partners.name'),
            value: 'name',
            filterType: 'text',
          },
          {
            text: this.$t('partners.tenant_id'),
            value: 'tenant_id',
            filterType: 'text',
          },
        ]
      },
      headers() {
        return this.formFilter.concat([
          {
            text: '',
            value: 'action',
            sortable: false,
          },
        ])
      },
      headerProps() {
        return {
          sortByText: this.$t('order.sortByText'),
        }
      },
      activeFilters() {
        return this.filters.data.filter((filter) => filter.active)
      },
    },
  }
</script>
